'use strict';

var template = require('../../templates/coupons/Modal.ejs');
var ModalFormView = require('commons/views/ModalForm');

module.exports = ModalFormView.extend({
    events: function() {
        var parentEvents = _.isFunction(ModalFormView.prototype.events) ?
            ModalFormView.prototype.events() :
            ModalFormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {template: template});
        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/coupons/Modal.js